import Modal from "../components/modal";
import react from 'react';

export default class DefineFieldRowsModal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      hideAction: props.hideAction
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() {
    this?.state?.hideAction && this?.state.hideAction();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    return (
      <>
        <Modal show = {this.state.show} header = { "Define field rows" } hideAction = {this.state.hideAction}>
          <div className="mb-6">
            <h3 className="h4-font-size subheading">Row distance</h3>
            <p>Define distance (in meters) between each row.</p>
            <div className="d-flex align-items-center">
              <img src="../field-default.png" alt="Small row distance" className="rounded object-fit-cover overflow-hidden mr-6" />
              <div className="icon icon-less-than h4-font-size text-fade-color mr-6" />
              <img src="../field-row-distance.png" alt="Small row distance" className="rounded object-fit-cover overflow-hidden mr-6" />
            </div>
          </div>
          <div className="mb-6">
            <h3 className="h4-font-size subheading">Row angle</h3>
            <p className="mb-2">Angle of the rows.</p>
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column justify-content-center mr-6">
                <h3 className="h5-font-size text-center text-fade-color">0°</h3>
                <img src="../field-row-angle-0.png" alt="Row angle 0°" className="rounded object-fit-cover overflow-hidden" />
              </div>
              <div className="d-flex flex-column justify-content-center mr-6">
                <h3 className="h5-font-size text-center text-fade-color">45°</h3>
                <img src="../field-row-angle-45.png" alt="Row angle 45°" className="rounded object-fit-cover overflow-hidden" />
              </div>
            </div>
          </div>
          <div className>
            <h3 className="h4-font-size subheading">Around the perimeter</h3>
            <p className="mb-2">If checked, rower will ride around the perimeter after filling the field.</p>
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column justify-content-center mr-6">
                <h3 className="h5-font-size text-center text-fade-color">Not checked</h3>
                <img src="../field-default.png" alt="Without route around the perimeter" className="rounded object-fit-cover overflow-hidden" />
              </div>
              <div className="d-flex flex-column justify-content-center mr-6">
                <h3 className="h5-font-size text-center text-fade-color">Checked</h3>
                <img src="../field-aroundPerimeter.png" alt="With route around the perimeter" className="rounded object-fit-cover overflow-hidden" />
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
};
